export function getMinDistance(inch) {
    switch (inch) {
        case '30':
            return '0,80m' ;
        case '32':
            return '1,00m';
        case '43':
            return '1,30m';
        case '50':
            return '1,50m';
        case '55':
            return '1,70m';
        case '60':
            return '1,90m';
        case '65':
            return '2,00m';
        case '70':
            return '2,20m';
        case '75':
            return '2,30m';
        case '85':
            return '2,60m';
        default:
            return '2,00m';
    }
}
